module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-segment-visualisation-middle.b5a44788.png";